import React from "react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import "./config/DatabaseConfig";
import router from "./routes/router";

function App() {
  return <RouterProvider router={router} />;
}

export default App;
